<template>
  <b-card title="Импорт полоски из архива">
    <b-form @submit.prevent="onSubmit">
      <b-row>
        <b-col md="6">
          <b-form-group label="ZIP-архив">
            <b-form-file
              v-model="form.archive"
              accept=".zip"
              placeholder="Выберите файл"
              browse-text="Обзор"
            />
            <small class="text-muted">Архив должен содержать минимум 5 файлов (mp3/jpg).</small>
          </b-form-group>

          <b-form-group label="Название полоски">
            <b-form-input v-model="form.name" placeholder="Название" />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group label="Автор">
            <v-select
              v-model="form.author_name"
              :options="authorsOptions"
              :reduce="opt => opt.value"
              label="label"
              :placeholder="isLoadingAuthors ? 'Загрузка…' : 'Выберите автора'"
              taggable
              :disabled="isLoadingAuthors"
            />
          </b-form-group>

          <b-form-group label="Шкала">
            <b-form-radio-group v-model="form.scale_type" :options="scaleOptions" />
          </b-form-group>

          <b-form-group v-if="form.scale_type === 'flat'" label="Номинал">
            <v-select
              v-model="form.base_price"
              :options="basePriceOptions"
              :reduce="opt => opt.value"
              label="label"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-progress v-if="uploadProgress > 0 && uploadProgress < 100" :value="uploadProgress" :max="100" class="mb-1" />
      <b-spinner v-if="uploadProgress === 100 && isUploading" small /> <span v-if="isUploading && uploadProgress === 100">Обработка файлов…</span>

      <b-button type="submit" variant="primary" :disabled="isUploading || !form.archive || !form.name">
        <b-spinner v-if="isUploading" small /> Импортировать
      </b-button>
    </b-form>
  </b-card>
</template>

<script>
import {
  BCard, BForm, BFormGroup, BFormInput, BFormFile, BFormRadioGroup, BButton, BRow, BCol, BSpinner, BProgress,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref, onUnmounted } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import store from '@/store'
import stripBuilderStoreModule from '../builder/stripBuilderStoreModule'

export default {
  components: {
    BCard, BForm, BFormGroup, BFormInput, BFormFile, BFormRadioGroup, BButton, BRow, BCol, BSpinner, BProgress,
    vSelect,
  },
  setup() {
    const STORE_MODULE_NAME = 'strip-builder'
    const toast = useToast()

    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, stripBuilderStoreModule)
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const form = ref({
      archive: null,
      name: '',
      author_name: null,
      scale_type: 'ascending',
      base_price: 100,
    })
    const isUploading = ref(false)
    const uploadProgress = ref(0)
    const authorsOptions = ref([])
    const isLoadingAuthors = ref(false)

    const scaleOptions = [
      { text: 'Возрастающая', value: 'ascending' },
      { text: 'Плоская', value: 'flat' },
    ]
    const basePriceOptions = [
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '300', value: 300 },
    ]

    isLoadingAuthors.value = true
    store.dispatch('strip-builder/fetchAuthors')
      .then(response => {
        authorsOptions.value = (response.data || []).map(a => ({
          label: a.name,
          value: a.name,
        }))
      })
      .catch(() => {})
      .finally(() => { isLoadingAuthors.value = false })

    const showToast = (title, variant) => {
      toast({
        component: ToastificationContent,
        props: {
          title,
          icon: variant === 'success' ? 'CheckIcon' : 'AlertTriangleIcon',
          variant,
        },
      })
    }

    const onSubmit = () => {
      isUploading.value = true
      uploadProgress.value = 0
      const formData = new FormData()
      formData.append('archive', form.value.archive)
      formData.append('name', form.value.name)
      if (form.value.author_name) formData.append('author_name', form.value.author_name)
      formData.append('scale_type', form.value.scale_type)
      if (form.value.scale_type === 'flat') formData.append('base_price', form.value.base_price)

      store.dispatch('strip-builder/importArchive', {
        formData,
        onUploadProgress: e => {
          if (e.total) uploadProgress.value = Math.round((e.loaded * 100) / e.total)
        },
      })
        .then(response => {
          isUploading.value = false
          showToast('Полоска импортирована', 'success')
          router.push({ name: 'strip-edit', params: { id: response.data.id } })
        })
        .catch(error => {
          isUploading.value = false
          uploadProgress.value = 0
          const msg = error.response?.data?.message || 'Ошибка импорта'
          showToast(msg, 'danger')
        })
    }

    return {
      form, isUploading, uploadProgress, authorsOptions, isLoadingAuthors, scaleOptions, basePriceOptions, onSubmit,
    }
  },
}
</script>
